{
  "title": "Nationalities",
  "add": "Add nationality",
  "edit": "Edit nationality",
  "columns": {
    "nameAr": "Name in Arabic",
    "nameEn": "Name in English"
  },
  "fields": {
    "nameAr": "Name in Arabic",
    "nameEn": "Name in English"
  },
  "deleteConfirm": {
    "title": "Delete {{name}}?",
    "description": "This nationality will disappear from the PDA lists. Transactions that already used it keep its name."
  },
  "toasts": {
    "created": "The nationality was created",
    "updated": "The nationality was updated",
    "deleted": "The nationality was deleted"
  },
  "empty": "No data available"
}
